<div class="example-form settings-form">

    <mat-form-field>
        <mat-label>{{'FORM.speciesForm.name' | translate}}</mat-label>
        <input [formControl]="nameCtrl" matInput type="text" required>
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{'FORM.speciesForm.ageClassesMale' | translate}}</mat-label>
        <mat-chip-grid #chipListMaleAgeClasses aria-label="Fruit selection">
            <mat-chip-row
                *ngFor="let male of ageClassesMale"
                [selectable]="selectable"
                removable="true"
                (removed)="removeMaleAgeClass(male)">
                {{male}}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            <input
                #ageClassesMaleInput
                placeholder="{{'FORM.speciesForm.placeholder_new_age_male' | translate}}"
                [formControl]="ageClassesMaleCtrl"
                [matChipInputFor]="chipListMaleAgeClasses"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addAgeClassesMale($event)">
        </mat-chip-grid>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{'FORM.speciesForm.ageClassesFemale' | translate}}</mat-label>
        <mat-chip-grid #chipListFemaleAgeClasses aria-label="Fruit selection">
            <mat-chip-row
                *ngFor="let data of ageClassesFemale"
                [selectable]="selectable"
                removable="true"
                (removed)="removeFemaleAgeClass(data)">
                {{data}}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            <input
                #ageClassesMaleInput
                placeholder="{{'FORM.speciesForm.placeholder_new_age_female' | translate}}"
                [formControl]="ageClassesFemaleCtrl"
                [matChipInputFor]="chipListFemaleAgeClasses"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addAgeClassesFemale($event)">
        </mat-chip-grid>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{'FORM.speciesForm.ageClassesUnknown' | translate}}</mat-label>
        <mat-chip-grid #chipListUnknownAgeClasses aria-label="Fruit selection">
            <mat-chip-row
                *ngFor="let data of ageClassesUnknown"
                [selectable]="selectable"
                removable="true"
                (removed)="removeUnknownAgeClass(data)">
                {{data}}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            <input
                #ageClassesMaleInput
                placeholder="{{'FORM.speciesForm.placeholder_new_age_unknown' | translate}}"
                [formControl]="ageClassesUnknownCtrl"
                [matChipInputFor]="chipListUnknownAgeClasses"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addAgeClassesUnknown($event)">
        </mat-chip-grid>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{'FORM.speciesForm.qualityClasses' | translate}}</mat-label>
        <mat-chip-grid #chipListQualityClasses aria-label="Fruit selection">
            <mat-chip-row
                *ngFor="let data of qualityClasses"
                [selectable]="selectable"
                removable="true"
                (removed)="removeQualityClass(data)">
                {{data}}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            <input
                #ageClassesMaleInput
                placeholder="{{'FORM.speciesForm.placeholder_new_quala_class' | translate}}"
                [formControl]="qualityClassesCtrl"
                [matChipInputFor]="chipListQualityClasses"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addQualityClass($event)">
        </mat-chip-grid>
    </mat-form-field>

    <div>
        <button mat-raised-button class="my-4 first-stt-btn w-100" type="submit" (click)="onSubmit()" [disabled]="formInvalid || updateRight">
            {{ 'FORM.BTN_SAVE' | translate }}
        </button>

        <button [disabled]="isCreate || deleteRight" class="w-100 second-stt-btn mb-2" style="float:inline-end;" mat-button (click)="onDelete()">
            {{ 'FORM.BTN_DELETE' | translate }}
        </button>
    </div>

    


</div>